export default __webpack_public_path__ + "static/media/PC_image@3x.b8119a2e.png";